interface Props {
  status: string | undefined | null;
  size?: 'sm' | 'md';
}

const COLOR: Record<string, { dot: string; text: string }> = {
  active: { dot: 'bg-emerald-400', text: 'text-emerald-300' },
  succeeded: { dot: 'bg-emerald-400', text: 'text-emerald-300' },
  // health-probe states
  alive: { dot: 'bg-emerald-400', text: 'text-emerald-300' },
  banned: { dot: 'bg-rose-400', text: 'text-rose-300' },
  suspended: { dot: 'bg-amber-400', text: 'text-amber-300' },
  not_found: { dot: 'bg-rose-400', text: 'text-rose-300' },
  error: { dot: 'bg-zinc-500', text: 'text-zinc-400' },
  pending: { dot: 'bg-sky-400', text: 'text-sky-300' },
  email_sent: { dot: 'bg-amber-400', text: 'text-amber-300' },
  captcha: { dot: 'bg-amber-400', text: 'text-amber-300' },
  paused: { dot: 'bg-fuchsia-400', text: 'text-fuchsia-300' },
  failed: { dot: 'bg-rose-400', text: 'text-rose-300' },
};

// Friendlier labels where the raw status word isn't self-explanatory.
// Anything not listed renders its raw value.
const LABEL: Record<string, string> = {
  alive: 'available',
  error: 'check failed',
  not_found: 'banned',
};

export function StatusPill({ status, size = 'sm' }: Props) {
  const s = (status ?? 'unknown').toString();
  const c = COLOR[s] ?? { dot: 'bg-zinc-500', text: 'text-zinc-400' };
  const label = LABEL[s] ?? s;
  const sz =
    size === 'md'
      ? 'gap-1.5 px-2.5 py-1 text-xs'
      : 'gap-1.5 px-2 py-0.5 text-xs';
  return (
    <span
      className={`inline-flex items-center rounded-full bg-[var(--color-surface-2)] font-medium ring-1 ring-inset ring-[var(--color-border)] ${c.text} ${sz}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />
      {label}
    </span>
  );
}
